import React from 'react';
import { useNavigate } from 'react-router-dom';
import EventEmitter from 'src/utils/EventEmitter';
import './index.css';
import LogoutNotificationPage from './LogoutNotification';
import LoginAsCustomerView from './LoginAsCustomer';

const NotificationPage = (props) => {
  const navigate = useNavigate();
  const type = props ? props.showNotificationType : '';
  const closeNotification = (e) => {
    var nextLocation = '/';

    if (props) {
      if (type === "update-password" || type === "logout" || type === "login-as-customer" || type === "change-profile") {
        nextLocation = "/profile"
      }
      props.setShowNotification(false);
    }
    
    if (type === "change-profile") {
      EventEmitter.emit("show_notification", { value: false, type: null });
    } else if (type !== "logout" && type !== "login-as-customer") {
      navigate(nextLocation);
      var show_full = false;
      if (nextLocation === "/" || nextLocation === "/scripts" || nextLocation === "/orders" || nextLocation === "/profile") {
        show_full = false;
      } else {
        show_full = true;
      }
      EventEmitter.emit("show_full", { value: show_full });
      EventEmitter.emit("show_top_navigation", { value: false });
    }
  }

  return (
    <div className="notification-popup-container">
      <div className="notification-popup-container-background-black" onClick={(e) => closeNotification(e)}></div>
      <div className="notification-popup-container-content">
        {type === "logout" ?
          <div className="notification-popup-container-content-wrapper-logout">
            <LogoutNotificationPage closeNotification={closeNotification} />
          </div>
          : type === "login-as-customer" ? 
            <div className="notification-popup-container-content-wrapper-logout">
              <LoginAsCustomerView closeNotification={closeNotification} />
            </div>
            :''
        }
      </div>
    </div>
  );
};

export default NotificationPage;